import axios from 'axios';
import { API } from 'shared/api/loan';
import { EToken } from 'shared/enum';
import { baseApiUrl } from 'shared/consts';

export const refreshToken = async (): Promise<string | null> => {
  
  try {
    const refreshToken = localStorage.getItem(EToken.REFRESH);
    if (!refreshToken) return null;

    const response = await axios.post(`${baseApiUrl}${API.loan.authRefresh}`, { refreshToken });
 
    const newAccessToken = response.data?.accessToken;
    const newRefreshToken = response.data?.refreshToken;

    if (newAccessToken) {
      localStorage.setItem(EToken.ACCESS, newAccessToken);
      if (newRefreshToken) {
        localStorage.setItem(EToken.REFRESH, newRefreshToken);
      }
      return newAccessToken;
    }

    return null;
  } catch (error) {
    localStorage.removeItem(EToken.ACCESS);
    localStorage.removeItem(EToken.REFRESH);
    return null;
  }
};

